import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBQjyltmLXjJnoki5G4WEBedJPQI1Vv5pk",
  authDomain: "login-app-157a3.firebaseapp.com",
  projectId: "login-app-157a3",
  storageBucket: "login-app-157a3.appspot.com",
  messagingSenderId: "833104222818",
  appId: "1:833104222818:web:de5af06cdb0f261ddc8f3b",
  measurementId: "G-MNQ2HE0H3C"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
